import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

//Models
import { CurriculumReview } from "app/core/models/curriculum-review";
import { AssessmentFormat } from "app/core/models/assessment-format";
import { TlaFormat } from "app/core/models/tla-format";
import { Loading } from "app/core/models/loading";
import { CustomError } from "app/core/models/custom-error";
import { CourseOutcome } from "app/core/models/course-outcome";
import { QuestionSelectedOption } from "app/core/models/question-selected-option";
import { Question } from "app/core/models/question";
import { QuestionAnswerOption } from "app/core/models/question-answer-option";
import { AssessmentSelectedMethod } from "app/core/models/assessment-selected-method";
import { TlaSelectedOption } from "app/core/models/tla-selected-option";
import { QuestionTextAnswer } from "app/core/models/question-text-answer";

//services
import { CourseOutcomeService } from "app/core/services/course-outcome.service";
import { QuestionService } from "app/core/services/question.service";
import { AlertService } from "app/core/services/alert.service";
import { AssessmentService } from "app/core/services/assessment.service";
import { TlaService } from "app/core/services/tla.service";
import { TlaExtentOption } from "../../../shared/models/tla/tla-extent-option";

@Component({
  selector: "app-user-step-course-outcome-details",
  templateUrl: "./user-step-course-outcome-details.component.html",
  styleUrls: ["./user-step-course-outcome-details.component.scss"]
})
export class UserStepCourseOutcomeDetailsComponent implements OnInit {
  @Input()
  courseId: number;
  @Input()
  review: CurriculumReview;
  @Input()
  assessmentFormat: AssessmentFormat;
  @Input()
  tlaFormat: TlaFormat;

  // @Output()
  // nextStep: EventEmitter<string> = new EventEmitter();
  // @Output()
  // prevStep: EventEmitter<string> = new EventEmitter();
  @Output()
  disableNavigation: EventEmitter<boolean> = new EventEmitter();

  loading: Loading;

  // assessmentMethodsForCourse: Array<AssessmentSelectedMethod> = [];
  // tlaOptionsForCourse: Array<SelectedTlaOption> = [];
  courseOutcomes: Array<CourseOutcome> = [];

  questions: Array<Question> = [];

  //flag
  saving: boolean = false;
  isValueChanged: boolean = false;
  showCourseOutcomeForm: boolean = false;
  justSaved: boolean = false;

  assessmentMethodsForCourse: Array<AssessmentSelectedMethod> = [];
  selectedAssessmentIdsArray: Array<any> = [];

  tlaOptionsForCourse: Array<TlaSelectedOption> = [];
  selectedTlaIdsArray: Array<any> = [];

  answersArray: Array<any> = []; //format: questionsArray[outcomeId][questionId] = Question Object

  //errors

  loadError: CustomError;

  actionErrorTitle: string = "Error";

  actionErrors: Array<CustomError> = [];

  constructor(
    private courseOutcomeService: CourseOutcomeService,
    private questionService: QuestionService,
    private alertService: AlertService,
    private assessmentService: AssessmentService,
    private tlaService: TlaService
  ) {}

  getCourseOutcomes(courseId: number) {
    return this.courseOutcomeService.getCourseOutcomes(courseId).then(
      courseOutcomes => courseOutcomes,
      error => {
        throw error;
      }
    );
  }

  //assign current answers to questions and return
  // async loadAnswers(
  //   courseOutcome: CourseOutcome,
  //   questions: Array<Question>,
  //   callback
  // ) {

  //   console.log("Loading answers...");

  //   let questionsWithAnswers: Array<Question> = [];

  //   for (let question of questions) {
  //     let questionWithAnswer: Question = new Question(
  //       question.id,
  //       question.format,
  //       question.question,
  //       question.relatingTo,
  //       question.orderNum
  //     );

  //     if (question.format == "text") {
  //       let textAnswer: QuestionTextAnswer = await this.questionService.getTextAnswerForOutcome(
  //         this.review.id,
  //         courseOutcome.id,
  //         question.id
  //       );

  //       questionWithAnswer.textAnswer = new QuestionTextAnswer(
  //         textAnswer.id,
  //         textAnswer.textAnswer,
  //         null,
  //         null,
  //         null
  //       );
  //     }

  //     if (question.format == "checkbox" || question.format == "radio") {
  //       let answerOptions: Array<
  //         QuestionAnswerOption
  //       > = await this.questionService.getAnswerOptions(
  //         this.review.id,
  //         question.id
  //       );

  //       let selectedAnswerOptions: Array<
  //         QuestionSelectedOption
  //       > = await this.questionService.getSelectedAnswerOptionsForOutcome(
  //         this.review.id,
  //         courseOutcome.id,
  //         question.id
  //       );

  //       //convert to array
  //       let selectedOptionsArray: Array<QuestionSelectedOption> = [];

  //       selectedAnswerOptions.forEach(selectedOption => {
  //         selectedOptionsArray[
  //           selectedOption.selectedOptionId
  //         ] = selectedOption;
  //       });

  //       //set isSelected
  //       answerOptions.forEach(option => {
  //         if (selectedOptionsArray[option.id]) {
  //           option.isSelected = true;
  //           option.otherText =
  //             selectedOptionsArray[option.id].selectedOptionText;
  //         } else {
  //           option.isSelected = false;
  //           option.otherText = "";
  //         }
  //       });

  //       question.options = answerOptions;
  //     }

  //     questionsWithAnswers.push(questionWithAnswer);
  //   }

  //   console.log(questionsWithAnswers);

  //   callback(questionsWithAnswers);
  // }

  async ngOnInit() {
    
    this.loading = new Loading(true, "Loading...");

    try {
      //load course outcomes
      let courseOutcomes: Array<CourseOutcome> = await this.getCourseOutcomes(
        this.courseId
      );

      // let assessmentMethodsForCourse: Array<AssessmentSelectedMethod> = [];
      // let tlaOptionsForCourse: Array<TlaSelectedOption> = [];

      //get assessment methods if required
      if (this.assessmentFormat.isEnabled && this.assessmentFormat.requiredByCourseOutcome) {
        if (this.assessmentFormat.format == "list") {
          //get selected assessment methods in step 1
          //let currently selected assessment methods
          this.assessmentMethodsForCourse = await this.assessmentService.getSelectedAssessmentMethods(
            this.courseId,
            this.assessmentFormat.id
          );
        } else if (this.assessmentFormat.format == "text") {
          this.assessmentMethodsForCourse = await this.assessmentService.getAssessmentMethodsTextForCourse(
            this.courseId,
            this.assessmentFormat.id
          );
        }

        //format is {id, courseOutcomeId, selectedAssessmentId, selectedAssessmentTextId, courseId} by all  course outcomes from API
        let selectedAssessmentIdsData: Array<
          any
        > = await this.assessmentService.getAllSelectedAssessmentMethodOptionsByCourseOutcomes(
          this.courseId,
          this.assessmentFormat.format
        );

        //convert the data above to key value array
        this.selectedAssessmentIdsArray = this.assessmentService.getAllSelectedAssessmentIdsByCourseOutcomes(
          courseOutcomes,
          this.assessmentMethodsForCourse,
          selectedAssessmentIdsData,
          this.assessmentFormat.format
        );
      }

      //get tla options if required
      if (this.tlaFormat.isEnabled && this.tlaFormat.requiredByCourseOutcome) {
        if (this.tlaFormat.format == "list") {
          this.tlaOptionsForCourse = await this.tlaService.getSelectedTlaOptionsForCourse(
            this.courseId,
            this.tlaFormat.id
          );
        } else if (this.tlaFormat.format == "text") {
          this.tlaOptionsForCourse = await this.tlaService.getSelectedTlaOptionsText(
            this.courseId,
            this.tlaFormat.id
          );
        }

        // console.log(this.tlaOptionsForCourse);

        let selectedTlaOptionIdsData: Array<
          any
        > = await this.tlaService.getAllSelectedTlaOptionsByCourseOutcomes(
          this.courseId,
          this.tlaFormat.format
        );

        // console.log(selectedTlaOptionIdsData);

        //convert the above data to array
        //conver the data above to key value array
        this.selectedTlaIdsArray = await this.tlaService.getAllSelectedTlaIdsByCourseOutcomes(
          courseOutcomes,
          this.tlaOptionsForCourse,
          selectedTlaOptionIdsData,
          this.tlaFormat.format
        );

        // console.log(this.selectedTlaIdsArray);
      }

      //get questions for course outcome
      let questions: Array<
        Question
      > = await this.questionService.getQuestionsByCourseId(
        this.courseId,
        "outcome"
      );

      this.questions = questions;

      for (let question of questions) {
        if (question.format == "checkbox" || question.format == "radio") {
          let options: Array<
            QuestionAnswerOption
          > = await this.questionService.getAnswerOptionsByCourseId(
            this.courseId,
            question.id
          );
          question.options = options;
        }
      }

      if (questions.length > 0) {
        courseOutcomes.forEach(courseOutcome => {
          courseOutcome.questions = questions;
        });
      }

      this.courseOutcomes = courseOutcomes;

      ///////////////////////////// get current answers for all questions ///////////////////////////////

      let answersArray: Array<any> = []; //format: questionsArray[outcomeId][questionId] = Question Object

      //initialize
      courseOutcomes.forEach(courseOutcome => {
        answersArray[courseOutcome.id] = [];

        questions.forEach(question => {
          let options = [];

          answersArray[courseOutcome.id][question.id] = {
            textAnswer: null,
            options: []
          };

          if (question.format == "checkbox" || question.format == "radio") {
            question.options.forEach(option => {
              answersArray[courseOutcome.id][question.id].options[option.id] = {
                isSelected: false,
                otherText: null
              };
            });
          }
        });
      });

      // console.log(answersArray);

      if (questions.length > 0) {
        let allTextAnswers = await this.questionService.getAllTextAnswersForCourse(
          this.courseId
        );

        allTextAnswers.forEach(textAnswer => {
          answersArray[textAnswer.outcomeId][textAnswer.questionId].textAnswer =
            textAnswer.textAnswer;
        });

        //get all list option questions
        // //format: allListAnswers[outcomeId][questionId] = QuestionAnswerOption
        let allListAnswers: Array<
          QuestionSelectedOption
        > = await this.questionService.getAllListAnswersForCourse(
          this.courseId
        );
        // console.log(allListAnswers);
        allListAnswers.forEach((listAnswer: QuestionSelectedOption) => {
          answersArray[listAnswer.outcomeId][listAnswer.questionId].options[
            listAnswer.selectedOptionId
          ] = { isSelected: true, otherText: listAnswer.selectedOptionText };
        });
        //   console.log(answersArray);
        this.answersArray = answersArray;
      }
    } catch (error) {
      console.log(error);
      this.loadError = error;
    } finally {
      // console.log(this.answersArray);
      this.loading.isLoading = false;
    }
  }

  radioSelectionChanged(outcomeId, questionId, selectedOptionId) {

    this.valueChanged();

    // console.log(outcomeId, questionId, selectedOptionId);

    for (let optionId in this.answersArray[outcomeId][questionId].options) {
      if (optionId == selectedOptionId) {
        this.answersArray[outcomeId][questionId].options[
          optionId
        ].isSelected = true;
      } else {
        this.answersArray[outcomeId][questionId].options[
          optionId
        ].isSelected = false;
      }
    }
  }

  /*******************************
   * Submit answers
   *******************************/
  async submitAnswers() {
    this.saving = true;

    let errors: Array<CustomError> = [];

    let selectedAssessmentMethodIds: Array<any> = [];
    let selectedTlaOptionIds: Array<any> = [];

    try {
      if (this.assessmentFormat.isEnabled && this.assessmentFormat.requiredByCourseOutcome) {
        this.selectedAssessmentIdsArray.map(
          (assessmentMethods, courseOutcomeId) => {
            assessmentMethods.map(
              (assessmentMethodSelected, assessmentMethodId) => {
                if (assessmentMethodSelected) {
                  selectedAssessmentMethodIds.push({
                    courseOutcomeId: courseOutcomeId,
                    selectedAssessmentId: assessmentMethodId
                  });
                }
              }
            );
          }
        );
      }

      if (this.tlaFormat.isEnabled && this.tlaFormat.requiredByCourseOutcome) {
        this.selectedTlaIdsArray.map((tlaOptions, courseOutcomeId) => {
          tlaOptions.map((tlaOptionSelected, tlaOptionSelectionId) => {
            if (tlaOptionSelected) {
              selectedTlaOptionIds.push({
                courseOutcomeId: courseOutcomeId,
                selectedTlaId: tlaOptionSelectionId
              });
            }
          });
        });
      }

      if (this.answersArray.length > 0) {
        let textAnswersArray = [];
        let listAnswersArray = [];

        for (let outcomeId in this.answersArray) {
          for (let questionId in this.answersArray[outcomeId]) {
            if (this.answersArray[outcomeId][questionId].textAnswer) {
              textAnswersArray.push({
                courseId: this.courseId,
                outcomeId: outcomeId,
                questionId: questionId,
                openText: this.answersArray[outcomeId][questionId].textAnswer
              });
            }

            if (this.answersArray[outcomeId][questionId].options.length > 0) {
              for (let optionId in this.answersArray[outcomeId][questionId]
                .options) {
                if (
                  this.answersArray[outcomeId][questionId].options[optionId]
                    .isSelected
                ) {
                  listAnswersArray.push({
                    courseId: this.courseId,
                    outcomeId: outcomeId,
                    questionId: questionId,
                    selectedAnswerOptionId: optionId,
                    otherText: this.answersArray[outcomeId][questionId].options[
                      optionId
                    ].otherText
                  });
                }
              }
            }
          }
        }

        if (textAnswersArray.length > 0) {
          await this.questionService.updateAllTextAnswersForCourse(
            this.courseId,
            textAnswersArray
          );
        }

        if (listAnswersArray.length > 0) {
          await this.questionService.updateAllListAnswersForCourse(
            this.courseId,
            listAnswersArray
          );
        }
      }

      if (this.assessmentFormat.requiredByCourseOutcome) {
        //save assessments
        await this.assessmentService.updateSelectedAssessmentMethodOptionByCourseOutcome(
          this.courseId,
          selectedAssessmentMethodIds,
          this.assessmentFormat.format
        );
      }

      if (this.tlaFormat.requiredByCourseOutcome) {
        await this.tlaService.updateSelectedTlaOptionByCourseOutcome(
          this.courseId,
          selectedTlaOptionIds,
          this.tlaFormat.format
        );
      }

      // this.alertService.showAlert(
      //   true,
      //   "Your answers have been saved successfully.",
      //   true,
      //   []
      // );

      this.justSaved = true;

      setTimeout(() => {
        this.justSaved = false;
      }, 2000);

    } catch (error) {
      console.log(error);
      this.actionErrors.push(error);
      window.scrollTo(0, 0);
    } finally {
      //save completed
      this.saving = false;
      this.isValueChanged = false;
      this.emitDisableNavigation(false);
    }
  }

  valueChanged() {
    this.isValueChanged = true;
    this.emitDisableNavigation(true);
  }

  emitDisableNavigation(isDisabled: boolean) {
    this.disableNavigation.emit(isDisabled);
  }
}
